import { render, staticRenderFns } from "./Reporte.vue?vue&type=template&id=0705c86f&"
import script from "./Reporte.vue?vue&type=script&lang=ts&"
export * from "./Reporte.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports